export enum QualifyLocalGenreDisplayConstants {
  Description = 1,
  Id = 2,
  Raw = 3
}
